import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Component, ContentChild, OnInit } from '@angular/core';
import { CompanyService } from '../services/company.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  minPw = 8;
  showPassword = true;
  showPasswordold = true;
  formGroup: FormGroup;


  // @ContentChild(IonInput) input: IonInput;
  constructor(
    private _companyservice: CompanyService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _toaster: ToastrService) { }
  newPasswordForm
  ngOnInit(): void {
    this.newPasswordForm = new FormGroup({
      'oldpassword': new FormControl('', [
        Validators.required,
      ]),
      'newPassword': new FormControl('', [
        Validators.required,
        Validators.min(10)
      ]),
      'newPasswordConfirm': new FormControl('', [
        Validators.required
      ])
    }, { validators: passwordMatchValidator });
}
  
resetPassword() {
  var passwordBody={
    password: this.newPasswordForm.value.oldpassword,
    newPassword: this.newPasswordForm.value.newPassword
  }
  this._companyservice.resetpassword(JSON.stringify(passwordBody)).subscribe((response) => {
    if (response.message == "Password is Updated") {
      this._toaster.info(response.message, "Success", { timeOut: 1000 });
      this.router.navigateByUrl("/dashboard/dashboard");
    } else {
      this._toaster.error(response.message, "Failed", { timeOut: 1000 });
    }
  });
}
toggleShow(val) {
  if(val == 'old' ){
    this.showPasswordold = !this.showPasswordold;
    // let ele = document.getElementById('oldpass').type='text';
    // ele.sett
  }
  else if(val=='new'){

    this.showPassword = !this.showPassword;
  }
  // this.input.type = this.showPassword ? 'text' : 'password';
}

}
export const passwordMatchValidator: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
  return formGroup.get('newPassword').value === formGroup.get('newPasswordConfirm').value ?
    null : { 'passwordMismatch': true };
}